exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/hkk/source/crazyaboutmath/src/app/fractions-numbers/fractions-numbers.component.css
// module id = ../../../../../src/app/fractions-numbers/fractions-numbers.component.css
// module chunks = main